import React, { useCallback, useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { parApi, parErr } from "@/lib/partnerApi";
import { GoldButton, ErrorLine } from "@/components/nds/windows/resident/ui";
import MemoList, { MemoFilters } from "./MemoList";
import MemoCompose from "./MemoCompose";
import MemoThread from "./MemoThread";

export const MEMOS_CHANGED = "tea:partner-memos-changed";

export default function PartnerMemosContent({ win }) {
  const [f, setF] = useState({ status: "open", unread: false, q: "", kind: "" });
  const [data, setData] = useState({ side: "staff", memos: [] });
  const [view, setView] = useState(win?.payload?.memoId ? { thread: win.payload.memoId } : "list");
  const [err, setErr] = useState(null);
  useEffect(() => { if (win?.payload?.memoId) setView({ thread: win.payload.memoId }); }, [win?.payload?.memoId, win?.payload?.nonce]);
  const load = useCallback(() => parApi.get("/memos", { status: view.thread ? "all" : f.status, unread: view.thread ? false : f.unread })
    .then((d) => { setData(d); setErr(null); }).catch((e) => setErr(parErr(e))), [f.status, f.unread, view.thread]);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  const changed = () => { load(); window.dispatchEvent(new Event(MEMOS_CHANGED)); };
  const q = f.q.trim().toLowerCase();
  const rows = data.memos.filter((m) => !f.kind || (m.kind === "internal" ? "internal" : "partner") === f.kind).filter((m) => !q || [m.subject, m.body, m.partner_name, m.resident?.name, m.to_staff?.name, m.author?.name].some((s) => (s || "").toLowerCase().includes(q)));
  const thread = view.thread && data.memos.find((m) => m.id === view.thread);
  return (
    <div data-testid="partner-memos-content" className="h-full overflow-y-auto p-5 space-y-4">
      <ErrorLine testId="pmemo-error">{err}</ErrorLine>
      {view === "compose" && <MemoCompose side={data.side} onCancel={() => setView("list")} onDone={(m) => { changed(); setView(m ? { thread: m.id } : "list"); }} />}
      {thread && <MemoThread memo={thread} side={data.side} onBack={() => setView("list")} onChanged={changed} />}
      {view === "list" && (
        <>
          <div className="flex items-center gap-3">
            <p className="text-[12px] text-nex-muted flex-1">{data.side === "staff" ? "Memos with partners and between staff. Every staff member sees every memo." : "Memos between you and TEA staff."}</p>
            <GoldButton onClick={() => setView("compose")} data-testid="pmemo-new"><Plus className="h-3 w-3" /> New memo</GoldButton>
          </div>
          <MemoFilters f={f} setF={setF} side={data.side} />
          <MemoList memos={rows} side={data.side} onOpen={(m) => setView({ thread: m.id })} />
        </>
      )}
    </div>
  );
}
